import {
  BENEFICIARY_DATA_REQUEST,
  BENEFICIARY_DATA_SUCCESS,
  BENEFICIARY_DATA_FAIL,
} from '../constants/beneficiaryConstants';

export const beneficiaryReducers = (state = { bnData: [] }, action) => {
  switch (action.type) {
    case BENEFICIARY_DATA_REQUEST:
      return { loading: true, bnData: [] };
    case BENEFICIARY_DATA_SUCCESS:
      return { loading: false, bnData: action.payload };
    case BENEFICIARY_DATA_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
